import { Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import styled from "styled-components";

export const StyledTextArea = styled(TextArea)`
    resize: none;
    font-family: inherit;
    font-size: 14px;
`;

export const StyledSelect = styled(Select)`
    width: 100%;
    height: auto;

    .ant-select-selector {
        padding: 7px 11px !important;
    }
`;
